// extracted by mini-css-extract-plugin
export default {"like":"_1nwyB","not-clickable":"a7mxz","notClickable":"a7mxz","likebutton":"_2iYyL","likes":"_2Zfef"};